export default __webpack_public_path__ + "static/char-37-073b26d4fb9ca0dfcf941ec96b042dba.gif";